<template>
  <div class="gender">
    <table>
      <thead>
        <tr>
          <td><b class="mini-font">GENDER</b></td>
          <td><b class="mini-font">TRAFFIC</b></td>
        </tr>
      </thead>
      <tbody v-if="gender">
        <tr v-for="(item, index) in Object.keys(gender)" :key="index" >
          <td><span class="subhead">{{item}}</span></td>
          <td><span class="subhead">{{gender[item] | formatNumber}}</span></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  name: 'adx-dashboard-campaignreport-gender',
  components: {

  },
  props: {

  },
  data() {
    return {
      gender: null
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.gender = this.$parent._data.dataDemographic.gender
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
